import React from "react";
import Page from "./page";

export default function Configuracion() {

  return <Page />;
}
